import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Button } from '@mui/material';
import TitleUser from '~/components/TitleUser';
import { Link } from 'react-router-dom';
import Pagination from '~/components/Pagination';
import images from '~/assets/images';
import classNames from 'classnames/bind';
import styles from './MyCourseOnline.module.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useNavigate } from 'react-router-dom';
import { myCourseOnline } from '~/Store/Action/courseActions';
import { format } from 'date-fns';
import slugify from 'slugify';

const cx = classNames.bind(styles);

const MyCourseOnline = () => {
    let navigate = useNavigate();

    const handleRedirect = () => {
        navigate('/tai-khoan/quan-ly-khoa-hoc/them-moi-khoa-hoc-online');
    };

    const dispatch = useDispatch();
    const listCourseOnline = useSelector((state) => state.course.listMyCourseOnline);

    const [user, setUser] = useState(null);

    const auth = useSelector((state) => state.auth);

    useEffect(() => {
        if (auth.user) {
            setUser(JSON.parse(auth.user));
        }
    }, [auth]);

    useEffect(() => {
        // Dispatch action để lấy dữ liệu khi component được mount
        dispatch(myCourseOnline(JSON.parse(auth.user)));
    }, []);

    return (
        <Box className={cx('MyCourseOnline')}>
            <div className={cx('title-user')}>
                <TitleUser title="Quản lý khóa học online" />
                <Button className="wow animate__animated animate__tada" onClick={handleRedirect}>
                    Thêm mới
                </Button>
            </div>
            <div className="row">
                {listCourseOnline?.data?.data?.length > 0 ? (
                    listCourseOnline?.data?.data?.map((item, index) => (
                        <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4">
                            <div className="wow animate__animated animate__flipInY">
                                <div className="card card-hover">
                                    <Link
                                        className="w-100"
                                        to={'/khoa-hoc-online/' + slugify(item.title) + '/' + item.id}
                                    >
                                        <LazyLoadImage
                                            src={item?.image}
                                            style={{ height: '144px' }}
                                            effect="blur"
                                            className="card-img-top"
                                            alt="Image Alt"
                                        />
                                    </Link>
                                    <div className="card-body" style={{ paddingBottom: 0 }}>
                                        <Link className="w-100" to="/">
                                            <p
                                                className="card-title text-dark fw-bold"
                                                style={{
                                                    fontFamily: 'sans-serif',
                                                    height: '50px',
                                                    textDecoration: 'none',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical',
                                                    display: '-webkit-box',
                                                    overflow: 'hidden',
                                                }}
                                            >
                                                {item?.title}
                                            </p>
                                        </Link>
                                        <div className="d-flex align-items-center">
                                            <span className="fs-4" style={{ color: 'rgba(39, 171, 96, 1)' }}>
                                                Doanh thu {item?.revenue}đ
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        className="card-footer"
                                        style={{ background: '#ffffff', border: 'none', padding: '14px 10px' }}
                                    >
                                        <div className="d-flex justify-content-between">
                                            <span className="text-dark fs-5">{item?.view} đã học</span>
                                            <span className="text-dark fs-5">
                                                {item?.opening_date
                                                    ? format(new Date(item?.created_at), 'dd/M/yyyy')
                                                    : ''}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <h2>Hiện tại không có khóa học video nào!</h2>
                )}
            </div>
        </Box>
    );
};

export default MyCourseOnline;
